import AutoDeliveryDcxHelpSupport from '../components/AutoDeliveryDcxHelpSupport';
import AutoDeliveryDcxMobileNumber from '../components/AutoDeliveryDcxMobileNumber';
import AutoDeliveryDcxOrder from '../components/AutoDeliveryDcxOrder';
import AutoDeliveryDcxOrderAddress from '../components/AutoDeliveryDcxOrderAddress';
import AutoDeliveryDcxPageDesktopLayout from '../components/AutoDeliveryDcxPageDesktopLayout';
import AutoDeliveryDcxPaymentMethod from '../components/AutoDeliveryDcxPaymentMethod';
import useSkipDelivery from '../hooks/useSkipDelivery';
import ConfirmSkipButton from './ConfirmSkipButton';
import DeliverySkipSection from './DeliverySkipSection';

const SkipDeliveryDesktop = () => {
    const {
        order: {deliveryAddress, products, price, paymentInfo},
        autoDelivery: {isSkipDeliveryAvailable, isFreezed},
    } = useSkipDelivery();

    return (
        <AutoDeliveryDcxPageDesktopLayout>
            <AutoDeliveryDcxPageDesktopLayout.Start
                footer={isSkipDeliveryAvailable ? <ConfirmSkipButton /> : undefined}
            >
                <DeliverySkipSection />
                <AutoDeliveryDcxOrder
                    className='mt-0 snap-start'
                    products={products}
                    price={price}
                    isEditAllowed
                    isCompact
                />
            </AutoDeliveryDcxPageDesktopLayout.Start>
            <AutoDeliveryDcxPageDesktopLayout.End>
                <AutoDeliveryDcxPaymentMethod isUpdateDisabled={isFreezed} paymentInfo={paymentInfo} />
                <AutoDeliveryDcxOrderAddress address={deliveryAddress} isEditAllowed />
                <AutoDeliveryDcxMobileNumber />
                <AutoDeliveryDcxHelpSupport />
            </AutoDeliveryDcxPageDesktopLayout.End>
        </AutoDeliveryDcxPageDesktopLayout>
    );
};

export default SkipDeliveryDesktop;
